module.exports = __webpack_public_path__ + "static/media/koop_2x.c8a4f4a9.png";